import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {} from "../../../system";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import { allSharedComponents } from "../..";
import {
  translationConstants,
  modeConstants,
  questionTypes,
  feedbackTypes,
  Directions,
} from "../../../constants";
import { CourseActions } from "../../../redux/actions/course.action";

const FeedbackModal = (props) => {
  const {
    setValue,
    register,
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm();
  const initialFromData = {
    practionerCourseId: props.courseId,
    competitionParticipantId: null,
    feedBackType: feedbackTypes.FEED_BACK_TYPE_COURSE,
    feedbackQuestions: [],
  };
  const activeStars = [1, 2, 3, 4, 5];
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { SpinnerContainer } = allSharedComponents;
  const [formData, setFormData] = useState(initialFromData);
  const questions = useSelector((state) => state.CourseReducer.allQuestions);
  const viewData = useSelector((state) => state.CourseReducer.viewFeedback);
  const direction = useSelector((state) => {
    return state.LanguageChangeReducer.direction;
  });
  const onSubmit = (data) => {
    if (props.mode === modeConstants.ADD_MODE) {
      dispatch(
        CourseActions.addFeedback(formData, props.systemUserId, props.setShow)
      );
      // props.setShow(false);
    } else if (props.mode === modeConstants.VIEW_MODE) {
      const dataToSend = {
        practionerCourseId: props.courseId,
        status: data,
      };
      dispatch(CourseActions.publishOrDisableFeedback(dataToSend));
      props.setShow(false);
    }
  };

  useEffect(() => {
    if (viewData !== null && Object.keys(viewData).length > 0) {
      setFormData({
        ...formData,
        feedbackQuestions: viewData?.feedbackQuestions,
      });
    }
    // eslint-disable-next-line
  }, [viewData]);

  const handleFormData = (data, value) => {
    if (props.mode === modeConstants.ADD_MODE) {
      // Convert value to string if it's not already a string
      const processedValue = String(value);
      const existingIndex = formData?.feedbackQuestions?.findIndex(
        (item) => item.id === data.id
      );
      if (existingIndex !== -1) {
        // If data exists, update it
        const updatedFeedbackQuestions = [...formData.feedbackQuestions];
        updatedFeedbackQuestions[existingIndex] = {
          ...updatedFeedbackQuestions[existingIndex],
          answer: processedValue,
        };
        setFormData({
          ...formData,
          feedbackQuestions: updatedFeedbackQuestions,
        });
      } else {
        // If data doesn't exist, add it
        setFormData({
          ...formData,
          feedbackQuestions: [
            ...formData.feedbackQuestions,
            {
              id: data.id,
              question: data.question,
              arabicQuestion: data.arabicQuestion,
              questionType: data.questionType,
              answer: processedValue,
            },
          ],
        });
      }
    }
  };

  useEffect(() => {
    setFormData(initialFromData); // Reset formData when component mounts
  }, [props.courseId]);

  return (
    <section className="student-section">
      <div className="ViewHeader">
        <p className="viewUserPara">
          {" "}
          {t(translationConstants.COURSE_FEEDBACK)}
        </p>
      </div>
      <p className="horizentalLine" />
      <div className="m-t-24">
        <Form
          validated
          className="ViewUserContent"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="row">
            <div className="col-12 col-md-6">
              {questions?.data?.map((data, index) => (
                <div key={index} className="my-3">
                  {data.questionType === questionTypes.QUESTION_TYPE_STAR && (
                    <>
                      <p className="feedback-text">
                        {direction === Directions.rtl
                          ? data?.arabicQuestion
                            ? data?.arabicQuestion
                            : data.question
                          : data.question}
                      </p>
                      {activeStars.map((star) => (
                        <span
                          key={star}
                          className={
                            star <=
                            parseInt(
                              formData?.feedbackQuestions?.find(
                                (item) => item.id === data.id
                              )?.answer || 0
                            )
                              ? `feedback-stars ${
                                  props.mode === modeConstants.VIEW_MODE
                                    ? "feedback-stars-disabled"
                                    : "text-warning"
                                }`
                              : "feedback-stars"
                          }
                          onClick={() => {
                            setValue(`star${index}`, star);
                            trigger(`star${index}`);
                            handleFormData(data, star);
                          }}
                          {...register(`star${index}`, { required: true })}
                        >
                          &#9733;
                        </span>
                      ))}
                      <br />
                      {errors[`star${index}`] && (
                        <p className="errorText">
                          {t(translationConstants.FIELD_IS_REQUIRED)}
                        </p>
                      )}
                    </>
                  )}
                </div>
              ))}
            </div>
            <div className="col-12 col-md-6">
              {questions?.data?.map((data, index) => (
                <div key={index} className="my-3">
                  {data.questionType === questionTypes.QUESTION_TYPE_RADIO && (
                    <>
                      <p className="feedback-text">
                        {" "}
                        {direction === Directions.rtl
                          ? data?.arabicQuestion
                            ? data?.arabicQuestion
                            : data.question
                          : data.question}
                      </p>
                      <div className="d-flex gap-3">
                        <Form.Check
                          type="radio"
                          label={t(translationConstants.YES)}
                          name={`radioGroup${index}`}
                          id={`yes${index}`}
                          onClick={(e) => {
                            if (props.mode !== modeConstants.VIEW_MODE) {
                              handleFormData(data, "yes");
                            }
                          }}
                          disabled={props.mode === modeConstants.VIEW_MODE}
                          {...register(`radioGroup${index}`, {
                            required: true,
                          })}
                          {...(props.mode === modeConstants.VIEW_MODE &&
                            formData.feedbackQuestions.some(
                              (item) =>
                                item.id === data.id && item.answer === "yes"
                            ) && { checked: true })}
                        />

                        <Form.Check
                          type="radio"
                          label={t(translationConstants.NO)}
                          name={`radioGroup${index}`}
                          id={`no${index}`}
                          onClick={() => {
                            handleFormData(data, "no");
                          }}
                          disabled={props.mode === modeConstants.VIEW_MODE}
                          {...register(`radioGroup${index}`, {
                            required: true,
                          })}
                          {...(props.mode === modeConstants.VIEW_MODE &&
                            formData.feedbackQuestions.some(
                              (item) =>
                                item.id === data.id && item.answer === "no"
                            ) && { checked: true })}
                        />
                      </div>
                    </>
                  )}
                  {errors[`radioGroup${index}`] && (
                    <p className="errorText">
                      {t(translationConstants.FIELD_IS_REQUIRED)}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="row">
            <div className="col-12 my-2">
              {questions?.data?.map((data, index) => (
                <div>
                  {data.questionType === questionTypes.QUESTION_TYPE_TEXT && (
                    <>
                      <p className="feedback-text mb-2">
                        {" "}
                        {direction === Directions.rtl
                          ? data?.arabicQuestion
                            ? data?.arabicQuestion
                            : data.question
                          : data.question}
                      </p>

                      <Form.Group className="form-group-register">
                        <Form.Control
                          as="textarea" // Set the "as" prop to "textarea"
                          {...register(`text${index}`, {
                            required: t(translationConstants.FIELD_IS_REQUIRED),
                          })}
                          value={
                            formData?.feedbackQuestions?.find(
                              (item) => item.id === data.id
                            )?.answer
                          } // Adjust value and onChange accordingly
                          onChange={(e) => {
                            setValue(`text${index}`, e.target.value);
                            trigger(`text${index}`);
                            handleFormData(data, e.target.value);
                          }}
                          id={"text" + `${index}`}
                          disabled={props.mode === modeConstants.VIEW_MODE}
                        />
                      </Form.Group>
                      {errors[`text${index}`] && (
                        <p className="errorText">
                          {t(translationConstants.FIELD_IS_REQUIRED)}
                        </p>
                      )}
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
          {viewData?.averageScore > 0 ? (
            <div className="row">
              <div className="col-12 my-2">
                <p className="feedback-score-text">
                  {t(translationConstants.TOTAL_SCORE)}:{" "}
                  <span className="feedback-score-value">
                    {viewData?.averageScore}
                  </span>
                </p>
              </div>
            </div>
          ) : (
            ""
          )}

          {props.mode === modeConstants.VIEW_MODE &&
          viewData?.status === feedbackTypes.FEED_BACK_TYPE_PENDING ? (
            <div className="d-flex justify-content-center">
              <Button
                className="SubmitDocs-button feedback-button"
                type="button"
                onClick={() => onSubmit(feedbackTypes.FEED_BACK_TYPE_APPROVED)}
              >
                {
                  t(translationConstants.PUBLISH)
                }
              </Button>
              <Button
                className="SubmitDocs-button feedback-button feedback-button-disable"
                type="button"
                onClick={() => onSubmit(feedbackTypes.FEED_BACK_TYPE_REJECTED)}
              >
                {
                  t(translationConstants.DISABLE)
              }
              </Button>
              <Button
                className="SubmitDocs-button 
                feedback-button
                feedback-button-cancel"
                type="button"
                onClick={() => props.setShow(false)}
              >
                {t(translationConstants.CANCEL)
                }
              </Button>
            </div>
          ) : props.mode === modeConstants.ADD_MODE ? (
            <Button
              className="SubmitDocs-button"
              type="submit"

            >
              {t(translationConstants.submit)}
            </Button>
          ) : (
            ""
          )}
        </Form>
      </div>
    </section>
  );
};

export default FeedbackModal;
